import AbstractCommand from "../../../core/application/AbstractCommand";
import CharacterLibrary from "../model/CharacterLibrary";
import CharacterModel from "../model/CharacterModel";
import CharactersConfig from "../model/CharactersConfig";
import CharacterTracker from "../model/CharacterTracker";

export default class InitializeCharactersCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {CharactersConfig} charactersConfig 
     * @param {CharacterLibrary} characterLibrary 
     */
    constructor(dispatcher, charactersConfig, characterLibrary) {
        super(dispatcher);

        this._charactersConfig = charactersConfig;
        this._characterLibrary = characterLibrary;
    }

    execute(evt) {
        const characters = this._charactersConfig.characters
            .map(characterConfig => new CharacterModel({
                ...characterConfig.toObject(),
                trackers: characterConfig.trackers.map(trackerConfig => new CharacterTracker(trackerConfig)),
            }));

        this._characterLibrary.registerCharacters(characters);
    }
}
